import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { User } from '@stylehaven/components';
import { UserState } from '../shared-state.interface';
import { UserActions, UserActionTypes } from './user.actions';

export const userAdapter: EntityAdapter<User> = createEntityAdapter<User>({
    selectId: user => user.Id
});
export const emptyState: UserState = userAdapter.getInitialState();

export const initialState: UserState = emptyState;

export function userReducer(state = initialState, action: Action): UserState {
    const specificAction: UserActions = action as UserActions;
    switch (specificAction.type) {
        case UserActionTypes.Set:
            return userAdapter.addOne(specificAction.payload, emptyState);
        case UserActionTypes.Unset:
            return userAdapter.removeAll(state);
        default:
            return state;
    }
}
